import { useDebounce } from "../../../lib/hooks/debounce";
import { keycloak } from "../../../lib/keycloak";
import { useAppSelector } from "../../../lib/redux/hooks";
import { groupBy } from "../../../lib/utils";
import { SearchIcon } from "../../../ui/icons/search";
import Input from "../../../ui/molecules/input";
import { SelectCustom } from "../../../ui/molecules/select";
import { UserRole } from "../../users/dto";
import { SelectUser } from "../../users/select/userSelect";
import { FindAllProjectsFilters, ProjectStateEnum } from "../dto";

interface Props {
    filters: FindAllProjectsFilters
    setFilters: (filters: Partial<FindAllProjectsFilters>) => void
}
export function ProjectsFilters({ filters, setFilters }: Props) {
    const atecosState = useAppSelector(state => state.atecos)
    const debounce = useDebounce((value) => setFilters({ name: value }), 1000)

    return (
        <div
            className="px-4"
            style={{
                display: 'flex',
                flexShrink: 0,
                justifyContent: 'flex-start',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                height: '64px',
            }}
        >
            <Input
                startIcon={<SearchIcon color={""} size={0} />}
                placeholder="Cerca nei progetti"
                onChangeText={(value) =>
                    debounce(value)
                }
                defaultValue={filters.name}
            />
            {
                !(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')) &&
                <SelectUser
                    isMulti={false}
                    id="select-teamleaders-project-filters"
                    role={UserRole.team_leader}
                    value={filters.teamLeaderId || undefined}
                    onChange={(v) => setFilters({ teamLeaderId: v ?? undefined })}
                    placeholder="Team Leaders"
                    isClearable
                />
            }
            {
                !(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')) &&
                <SelectUser
                    isMulti={true}
                    id="select-commercials-project-filters"
                    role={UserRole.commercial}
                    value={filters.commercial || []}
                    onChange={(v) => setFilters({ commercial: v })}
                    placeholder="Commerciali"
                    isClearable
                    keepOverflow
                />
            }
            <SelectCustom
                isClearable
                placeholder="Settore"
                options={groupBy(atecosState.findAllAtecosResponse, "sector").map(sector => ({ label: sector.key, value: sector.key }))}
                onChange={(value) => setFilters({ sector: Array.isArray(value) ? value.map(v => v) : value ? [value] : undefined })}
                defaultValue={filters.sector}
            />
            <SelectCustom
                isClearable
                placeholder="Categoria"
                options={groupBy(atecosState.findAllAtecosResponse, "category").map(sector => ({ label: sector.key, value: sector.key }))}
                onChange={(value) => setFilters({ category: Array.isArray(value) ? value.map(v => v) : value ? [value] : undefined })}
                defaultValue={filters.category}
            />
            <SelectCustom
                isClearable
                placeholder="Stato"
                options={[
                    { label: "Da iniziare", value: ProjectStateEnum.TOSTART },
                    { label: "In corso", value: ProjectStateEnum.INPROGRESS },
                    { label: "Sospeso", value: ProjectStateEnum.SUSPENDED },
                    { label: "Concluso", value: ProjectStateEnum.CONCLUDED },
                ]}
                onChange={(value) => setFilters({ state: value ? (Array.isArray(value) ? value.map(v => v as ProjectStateEnum) : [value as ProjectStateEnum]) : [] })}
                defaultValue={filters.state}
            />
        </div>
    )
}